import variableStyles from './variable-styles';

const bannerScreenLight = {
  bannerScreenHeader: '#E8773D',
  bannerScreenTitle: '#666666',
  bannerScreenDesc: '#6e708e',
  bannerBg: 'linear-gradient(0deg, rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.85)), #F45C0E',
};

const bannerScreenDark = {
  bannerScreenHeader: '#E8773D',
  bannerScreenTitle: '#FFFFFF',
  bannerScreenDesc: '#c4c6d8',
  bannerBg: 'rgba(119, 130, 146, 0.15)',
};

const topicsLight = {
  topicsHeader: '#E8773D',
  topicsTitle: '#5a5b74',
  countNumber: '#8A8CB2',
  countLabel: '#f67e3e',
};

const topicsDark = {
  topicsHeader: '#E8773D',
  topicsTitle: '#FFFFFF',
  countNumber: '#FFFFFF',
  countLabel: '#f67e3e',
};

const metaverseLight = {
  metaverseHeader: '#E8773D',
  metaverseTitle: '#5a5b74',
  metaverseContentTitle: '#5a5b74',
  metaverseContentDesc: '#6e708e',
};

const metaverseDark = {
  metaverseHeader: '#E8773D',
  metaverseTitle: '#FFFFFF',
  metaverseContentTitle: '#FFFFFF',
  metaverseContentDesc: '#c4c6d8',
};

const benefitsLight = {
  benefitsHeader: '#E8773D',
  benefitsTitle: '#5a5b74',
  benefitsDesc: '#6e708e',
  benefitsContentTitle: '#5a5b74',
  benefitsContentDesc: '#6e708e',
};

const benefitsDark = {
  benefitsHeader: '#E8773D',
  benefitsTitle: '#FFFFFF',
  benefitsDesc: '#b3b4cd',
  benefitsContentTitle: '#FFFFFF',
  benefitsContentDesc: '#c4c6d8',
};

const journeyLight = {
  journeyHeader: '#E8773D',
  journeyTitle: '#5a5b74',
  journeyDesc: '#6e708e',
  journeyItemLabel: '#E8773D',
  journeyItemDesc: '#454659',
  journeyBoxBg: 'linear-gradient(135.12deg, rgba(244, 245, 255, 0.4) 0.4%, rgba(255, 209, 121, 0.4) 100%)',
};

const journeyDark = {
  journeyHeader: '#E8773D',
  journeyTitle: '#FFFFFF',
  journeyDesc: '#b3b4cd',
  journeyItemLabel: '#E8773D',
  journeyItemDesc: '#b3b4cd',
  journeyBoxBg: 'linear-gradient(210.66deg, rgba(175, 198, 255, 0.157036) 60.09%, rgba(255, 255, 255, 0) 93.19%)',
};

const fatTokenLight = {
  fatTokenHeader: '#E8773D',
  fatTokenTitle: '#5a5b74',
  fatTokenDesc: '#454659',
  fatTokenBoxBg: 'linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04)), #FFFFFF',
  boxBorder: 'unset',
};

const fatTokenDark = {
  fatTokenHeader: '#E8773D',
  fatTokenTitle: '#FFFFFF',
  fatTokenDesc: '#b3b4cd',
  fatTokenBoxBg: 'linear-gradient(210.66deg, rgba(175, 198, 255, 0.157036) 60.09%, rgba(255, 255, 255, 0) 93.19%)',
  boxBorder: '1px solid #afbffa',
};

const caloTokenLight = {
  caloTokenHeader: '#E8773D',
  caloTokenTitle: '#5a5b74',
  caloTokenDesc: '#454659',
  caloTokenBoxBg: 'linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04)), #FFFFFF',
};

const caloTokenDark = {
  caloTokenHeader: '#E8773D',
  caloTokenTitle: '#FFFFFF',
  caloTokenDesc: '#b3b4cd',
  caloTokenBoxBg: 'linear-gradient(210.66deg, rgba(175, 198, 255, 0.157036) 60.09%, rgba(255, 255, 255, 0) 93.19%)',
};

const tokenmetricsLight = {
  tokenmetricsHeader: '#E8773D',
  tokenmetricsTitle: '#5a5b74',
  tokenmetricsDesc: '#454659',
  inputBg: 'linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04)), #FFFFFF',
  inputBorder: '1px solid #ff7510',
};

const tokenmetricsDark = {
  tokenmetricsHeader: '#E8773D',
  tokenmetricsTitle: '#FFFFFF',
  tokenmetricsDesc: '#b3b4cd',
  inputBg: '#121C38',
  inputBorder: '1px solid #2b3757',
};

const teamLight = {
  infoName: '#5a5b74',
  infoJobDesc: '#454659',
};

const teamDark = {
  infoName: '#FFFFFF',
  infoJobDesc: '#b3b4cd',
};

const launchpadLight = {
  launchpadCardBg: 'linear-gradient(0deg, rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.85)), #F45C0E',
  launchpadCardLabel: '#4D4D4D',
  launchpadCardNumber: '#1A1A1A',
  launchpadBtnBg: 'linear-gradient(169.91deg,#ffaa4e 2.45%,#f25307 95.14%)',
};

const launchpadDark = {
  launchpadCardBg: 'linear-gradient(210.66deg, rgba(175, 198, 255, 0.157036) 60.09%, rgba(255, 255, 255, 0) 93.19%)',
  launchpadCardLabel: '#cccccc',
  launchpadCardNumber: '#ffffff',
  launchpadBtnBg: '#232f5d',
};

const partnersLight = {
  partnerCardBg: 'transparent',
};

const partnersDark = {
  partnerCardBg: 'transparent',
};

const documentsLight = {
  itemTitle: '#5a5b74',
  itemText: '#454659',
  itemBg: 'linear-gradient(135.12deg, rgba(244, 245, 255, 0.4) 0.4%, rgba(255, 209, 121, 0.4) 100%)',
};

const documentsDark = {
  itemTitle: '#FCFCFC',
  itemText: '#FCFCFC',
  itemBg: 'linear-gradient(210.66deg, rgba(175, 198, 255, 0.157036) 60.09%, rgba(255, 255, 255, 0) 93.19%)',
};

const addressHeaderLight = {
  addressBg: '#ffffff',
  auditBox: 'linear-gradient(180deg, #FFAA4E 0%, #F45C0E 100%)',
  auditShadow: '2px 2px 50px -5px rgba(249, 131, 75, 0.8)',
  badgeBg: '#FFFFFF',
  badgeBorder: '0.5px solid #F45C0E',
  badgeTxt: '#f67d3e',
}

const addressHeaderDark = {
  addressBg: '#0C1224',
  auditBox: 'linear-gradient(210.66deg, rgba(175, 198, 255, 0.157036) 60.09%, rgba(255, 255, 255, 0) 93.19%)',
  auditShadow: 'unset',
  badgeBg: 'linear-gradient(0deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.04)), #171F36',
  badgeBorder: '0.5px solid #58FE90',
  badgeTxt: '#46cb73',
}

// --- Theme Mode --- //
const lightTheme = {
  body: variableStyles.lightTheme,
  header: '#E8773D',
  title: '#5a5b74',
  description: '#454659',
  cursorBorder: '0.5px solid #5a5b74',
  ...addressHeaderLight,
  ...bannerScreenLight,
  ...topicsLight,
  ...metaverseLight,
  ...benefitsLight,
  ...journeyLight,
  ...fatTokenLight,
  ...caloTokenLight,
  ...tokenmetricsLight,
  ...teamLight,
  ...documentsLight,
  ...launchpadLight,
  ...partnersLight,
};

const darkTheme = {
  body: variableStyles.darkTheme,
  header: '#E8773D',
  title: '#FFFFFF',
  description: '#b3b4cd',
  cursorBorder: '0.5px solid white',
  ...addressHeaderDark,
  ...bannerScreenDark,
  ...topicsDark,
  ...metaverseDark,
  ...benefitsDark,
  ...journeyDark,
  ...fatTokenDark,
  ...caloTokenDark,
  ...tokenmetricsDark,
  ...teamDark,
  ...documentsDark,
  ...launchpadDark,
  ...partnersDark,
};

export { lightTheme, darkTheme };
